import React, { JSX } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { DualSearchStore } from '@App/stores/search/party/dual-search-store'
import clsx from 'clsx'

interface AnimatedDualSearchTablesProps<resultType> {
    dualSearchStore: DualSearchStore<resultType>
    primarySearchTable: JSX.Element
    secondarySearchTable: JSX.Element
}

const AnimatedDualSearchTables = <resultType,>({
    dualSearchStore,
    primarySearchTable,
    secondarySearchTable,
}: AnimatedDualSearchTablesProps<resultType>) => (
    <div
        className={clsx(
            'animated-dual-search-tables',
            dualSearchStore.showWorks && 'animated-dual-search-tables-show-works'
        )}
    >
        <div
            key={`primary-${dualSearchStore.showWorks}`}
            className="animated-dual-search-tables-panel animated-dual-search-tables-primary"
            aria-hidden={dualSearchStore.showWorks}
        >
            {primarySearchTable}
        </div>
        <div
            key={`secondary-${dualSearchStore.showWorks}`}
            className="animated-dual-search-tables-panel animated-dual-search-tables-secondary"
            aria-hidden={!dualSearchStore.showWorks}
        >
            {secondarySearchTable}
        </div>
    </div>
)

export default observer(AnimatedDualSearchTables)
